export default __webpack_public_path__ + "static/media/gatia_space_view_preview.e1503f8d.png";